
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Tours dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence Google Ads à Tours certifiée Google Partner, accompagne les entreprises tourangelles pour doper leur visibilité et générer plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Tours dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO est une agence Google Ads à Tours certifiée Google Partner, accompagne les entreprises tourangelles pour doper leur visibilité et générer plus de prospects.",
        },
      ],
    };
  },
};
